interface ScalePadLogoProps {
  size?: 'xs' | 'sm' | 'md';
}

export function ScalePadLogo({ size = 'md' }: ScalePadLogoProps) {
  const height = size === 'xs' ? 14 : size === 'sm' ? 17 : 22;
  const width = Math.round((height * 429.1) / 65.3);

  return (
    <span
      role="img"
      aria-label="ScalePad"
      style={{ display: 'inline-flex', flex: '0 0 auto' }}
    >
      <img
        src="/brand/scalepad-wordmark.svg"
        alt=""
        aria-hidden
        className="scalepad-wordmark"
        width={width}
        height={height}
        style={{ display: 'block', height, width }}
      />
    </span>
  );
}
